import { useIsCustomerUserRegisteredApi } from 'graphql/generated';
import useDebounce from 'hooks/helpers/UseDebounce';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';

type EmailAlreadyRegistered = {
    email: string | null;
};

export const useEmailAlreadyRegistered = ({ email }: EmailAlreadyRegistered) => {
    const debouncedEmailValue = useDebounce(email, 500);
    const { isUserLoggedIn } = useCurrentUserData();
    const [{ data: customerData }] = useIsCustomerUserRegisteredApi({
        variables: { email: debouncedEmailValue ?? '' },
        pause: isUserLoggedIn || !debouncedEmailValue,
        requestPolicy: 'network-only',
    });

    return {
        isEmailAlreadyRegistered:
            customerData?.isCustomerUserRegistered !== undefined && debouncedEmailValue
                ? customerData.isCustomerUserRegistered
                : null,
    };
};
